import React from 'react';
import {
  Box,
  Grid,
  Table,
  TableBody,
  TableContainer,
  TablePagination,
  Pagination,
  Stack,
  useMediaQuery,
  Switch,
  FormControlLabel,
  TableRow,
  TableCell,
  IconButton,
} from '@mui/material';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import ManIcon from '@mui/icons-material/Man';
import {
  BackdropLoading,
  BookButton,
  BookSearchField,
  BookSearchDropDownField,
  CardComponent,
} from '../../components';

import { WHITE_COLOR, GREY_COLOR } from '../../styles/constants';
import { TableHeadComponent, TableRows } from '../../components';
import BookModal from '../modals/book';
import { useTheme } from '@mui/material/styles';
import { useBook } from './hooks/book.hook';
import { useStyles } from './book.style';
import AddIcon from '@mui/icons-material/Add';

const BookTable = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const {
    BookData,
    languageData,
    action,
    BookCount,
    open,
    setOpen,
    singleBook,
    tableCells,
    actionsIcons,
    limit,
    page,
    isLoading,
    handleGetBookData,
    handleAdd,
    handleActionClick,
    handleChangePage,
    calculatePagesCount,
    handleChangeRowsPerPage,
    handleBookSearch,
    handleDropDown,
    handlePublish,
    searchKey,
  } = useBook();

  const dataIcons = [
    { id: 'author', title: 'Author Name', gridTitleSize: 5, gridSize: 6 },
    {
      id: 'bookName',
      title: 'Book Name',
      gridTitleSize: 5,
      gridSize: 6,
      icon: (
        <ManIcon
          sx={{
            fontSize: '19px',
            marginLeft: '2px',
          }}
        />
      ),
    },
    {
      id: 'bookNo',
      title: 'Book No',
      gridTitleSize: 5,
      gridSize: 7,
      icon: (
        <ContactPhoneIcon
          sx={{
            fontSize: '19px',
            marginLeft: '2px',
          }}
        />
      ),
    },
  ];

  return (
    <Box component='div' sx={isMobile && { paddingBottom: 10 }}>
      {open && (
        <BookModal
          tableCells={tableCells}
          open={open}
          setOpen={setOpen}
          singleBook={singleBook}
          action={action}
          handleGetBookData={handleGetBookData}
          languageData={languageData}
        />
      )}
      <BackdropLoading open={isLoading} />
      <Box
        component='div'
        sx={{
          width: '100%',
          position: isMobile && 'sticky',
          top: isMobile && '7rem',
          zIndex: isMobile && 1000,
          background: 'white',
        }}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={2} lg={2}>
          <BookSearchDropDownField
                type='select'
                searchKey={searchKey}
                handleDropDown={handleDropDown}
                sx={{ width: isMobile ? '100%' : '100%' }}
                selectOptions={[
                   { value: 'author', text: 'Author Name' },
                   { value: 'bookName', text: 'Book Name' },
                ]}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={8} lg={8}>
              <BookSearchField
                type='text'
                handleSearch={handleBookSearch}
                sx={{ width: isMobile ? '100%' : '50%' }}
              />
            </Grid>
          <Grid item xs={12} sm={12} md={2} lg={2}>
            <BookButton
              onSubmit={handleAdd}
              title='Add Book'
              type='primary'
              variant='contained'
              icon={<AddIcon />}
            />
          </Grid>
        </Grid>
      </Box>
      {isMobile ? (
        <>
          {BookData &&
            Object.keys(BookData).length > 0 &&
            BookData?.map(row => (
              <CardComponent
                key={'BookDara' + row.id}
                sx={{
                  background: GREY_COLOR.GHOSTWHITE,
                  width: '97%',
                  margin: '20px 5px 5px 5px',
                }}
                classBorder={
                  Object.keys(row['measurement']).length > 0
                    ? classes.statusCompleted
                    : classes.statusPending
                }
                titleStyle={classes.titleStyle}
                uniqueKey='-BookCrud'
                rows={row}
                dataIcons={dataIcons}
                tableCells={tableCells}
                actionsIcons={actionsIcons}
                handleActionClick={handleActionClick}
              />
            ))}
          <Stack className={classes.paginationStyle} spacing={2}>
            <Pagination
              count={calculatePagesCount(limit, BookCount)}
              page={page + 1}
              onChange={(event, newPage) => handleChangePage(true, newPage)}
              color='primary'
            />
          </Stack>
        </>
      ) : (
        <>
          <TableContainer
            sx={{
              width: '100%',
              background: WHITE_COLOR,
            }}
          >
            <Table sx={{ minWidth: '100%' }} aria-label='simple table'>
              <TableHeadComponent tableCells={tableCells} />
              <TableBody>
                {BookData &&
                  Object.keys(BookData).length > 0 &&
                  BookData?.map(row => (
                    <TableRow key={row.id + '-BookCrud'}>
                      {tableCells &&
                        Object.keys(tableCells).length > 0 &&
                        tableCells.map(t => {
                          let cellValue = row[t.id];
                          if (t.id === 'languageId' && cellValue) {
                            cellValue = row?.Language?.name || 'N/A';
                          }
                          
                          if (t.id === 'coverImage') {
                            return (
                              <TableCell key={t.id} align="left">
                                {cellValue ? (
                                  <img
                                    src={cellValue}
                                    alt="Cover"
                                    style={{
                                      width: '50px',
                                      height: '50px',
                                      objectFit: 'cover',
                                      borderRadius: '4px'
                                    }}
                                  />
                                ) : (
                                  <Box
                                    sx={{
                                      width: '50px',
                                      height: '50px',
                                      backgroundColor: '#f5f5f5',
                                      borderRadius: '4px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      color: '#999'
                                    }}
                                  >
                                    No Image
                                  </Box>
                                )}
                              </TableCell>
                            );
                          }
                          
                          if (t.id === 'isActive') {
                            return (
                              <TableCell key={t.id} align="center">
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={cellValue}
                                      onChange={(e) => handlePublish(row.id, e.target.checked)}
                                      color="primary"
                                    />
                                  }
                                  label={cellValue ? 'Active' : 'Inactive'}
                                  labelPlacement="end"
                                />
                              </TableCell>
                            );
                          }
                          
                          if (t.id === 'actions') {
                            return (
                              <TableCell key={t.id} align="left">
                                <Box sx={{ display: 'flex', gap: 1 }}>
                                  {actionsIcons.map((item, index) => (
                                    <IconButton
                                      key={index + 'icons'}
                                      onClick={() => handleActionClick(index, row)}
                                      size="small"
                                    >
                                      {item.icon}
                                    </IconButton>
                                  ))}
                                </Box>
                              </TableCell>
                            );
                          }
                          
                          return (
                            <TableCell key={t.id}>
                              {cellValue}
                            </TableCell>
                          );
                        })}
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            component='div'
            count={BookCount}
            page={page}
            onPageChange={(event, newPage) => handleChangePage(false, newPage)}
            rowsPerPage={limit}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[25, 50, 100, 250, 500, 750, 1000]}
          />
        </>
      )}
    </Box>
  );
};
export default BookTable;
